(() => {
  const initCustomVariantTab = (section) => {
    if (!section || section.dataset.customVariantTabReady === 'true') return;

    const tabs = Array.from(section.querySelectorAll('[data-custom-variant-tab-button]'));
    const panels = Array.from(section.querySelectorAll('[data-custom-variant-tab-panel]'));
    const tabsWrap = section.querySelector('[data-custom-variant-tabs-wrap]');
    const tabsScroll = section.querySelector('[data-custom-variant-tabs-scroll]');
    const tabsPrev = section.querySelector('[data-custom-variant-tabs-prev]');
    const tabsNext = section.querySelector('[data-custom-variant-tabs-next]');
    if (!tabs.length || !panels.length) return;

    section.dataset.customVariantTabReady = 'true';

    const updateTabsNavigation = () => {
      if (!tabsWrap || !tabsScroll) return;

      const maxScroll = Math.max(0, tabsScroll.scrollWidth - tabsScroll.clientWidth);
      const hasOverflow = maxScroll > 1;
      const isAtStart = !hasOverflow || tabsScroll.scrollLeft <= 1;
      const isAtEnd = !hasOverflow || tabsScroll.scrollLeft >= maxScroll - 1;

      tabsWrap.classList.toggle('is-overflowing', hasOverflow);
      tabsWrap.classList.toggle('is-at-start', isAtStart);
      tabsWrap.classList.toggle('is-at-end', isAtEnd);

      [tabsPrev, tabsNext].forEach((button) => {
        if (!button) return;
        const disabled = button === tabsPrev ? isAtStart : isAtEnd;
        button.disabled = disabled;
        button.setAttribute('aria-hidden', disabled ? 'true' : 'false');
      });
    };

    const scrollTabs = (direction) => {
      if (!tabsScroll) return;
      tabsScroll.scrollBy({
        left: direction * Math.max(120, tabsScroll.clientWidth * 0.7),
        behavior: 'smooth'
      });
    };

    const closeOpenModal = () => {
      section.querySelectorAll('.custom-variant-tab__modal[open]').forEach((modal) => {
        modal.close();
      });
    };

    const activateTab = (tab, focus = false) => {
      const panelId = tab.dataset.customVariantTabTarget;
      closeOpenModal();

      tabs.forEach((item) => {
        const isActive = item === tab;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        item.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        const isActive = panel.id === panelId;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
      });

      if (focus) tab.focus();

      if (tabsScroll && window.matchMedia('(max-width: 767px)').matches) {
        tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab));

      tab.addEventListener('keydown', (event) => {
        if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

        event.preventDefault();
        let nextIndex = index;

        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        activateTab(tabs[nextIndex], true);
      });
    });

    section.querySelectorAll('[data-custom-variant-modal-open]').forEach((button) => {
      button.addEventListener('click', () => {
        const modal = document.getElementById(button.dataset.customVariantModalOpen);
        if (modal && !modal.open) modal.showModal();
      });
    });

    section.querySelectorAll('[data-custom-variant-modal-close]').forEach((button) => {
      button.addEventListener('click', () => {
        button.closest('.custom-variant-tab__modal')?.close();
      });
    });

    section.querySelectorAll('.custom-variant-tab__modal').forEach((modal) => {
      modal.addEventListener('click', (event) => {
        if (event.target === modal) modal.close();
      });
    });

    if (tabsScroll) {
      tabsScroll.addEventListener('scroll', updateTabsNavigation, { passive: true });
      window.addEventListener('resize', updateTabsNavigation, { passive: true });
      updateTabsNavigation();
      window.requestAnimationFrame(updateTabsNavigation);
      window.addEventListener('load', updateTabsNavigation, { once: true });

      if ('ResizeObserver' in window) {
        const tabsResizeObserver = new ResizeObserver(updateTabsNavigation);
        tabsResizeObserver.observe(tabsScroll);
      }
    }

    if (tabsPrev) tabsPrev.addEventListener('click', () => scrollTabs(-1));
    if (tabsNext) tabsNext.addEventListener('click', () => scrollTabs(1));
  };

  const initAllCustomVariantTabs = () => {
    document.querySelectorAll('[data-custom-variant-tab]').forEach(initCustomVariantTab);
  };

  initAllCustomVariantTabs();

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-custom-variant-tab]').forEach(initCustomVariantTab);
  });
})();
